import { Snackbar } from 'src/app/shared/types/snackbar';

export const snackbarSucceedObject: Snackbar = {
  duration: 2000,
  message: 'profile.password.message_success',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'approved-snackbar',
};

export const snackbarFailedObject: Snackbar = {
  duration: 2000,
  message: 'profile.password.message_failed',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'error-snackbar',
};
